module.exports = __webpack_public_path__ + "fonts/NetflixSansMedium.4e39b9dc.ttf";